import React from 'react'

const CategoriesIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">
		<rect width="50" height="50" fill="#030A7E" fillOpacity="0.15" rx="25" />
		<path
			fill="#030A7E"
			fillRule="evenodd"
			d="M20.692 17H17v3.692h3.692V17zM17 23.154h3.692v3.693H17v-3.693zm0 6.154h3.692V33H17v-3.692zm6.154 0h3.692V33h-3.692v-3.692zm3.692-6.154h-3.692v3.693h3.692v-3.693zM23.154 17h3.692v3.692h-3.692V17zM33 29.308h-3.692V33H33v-3.692zm-3.692-6.154H33v3.693h-3.692v-3.693zM33 17h-3.692v3.692H33V17z"
			clipRule="evenodd"
		/>
	</svg>
)

export default CategoriesIcon
